<template>
    <div class="scene-checkpoint-answer">
        <div class="back-button">
            <img src="/images/game/back.png" @click="handleBack"/>
        </div>

        <img class="sprite" src="/images/game/sprite-4.png"/>

        <img class="title" :src="title"/>

        <div class="dialog">
            <span class="span1">小悦提示：</span>
            <span class="span2">您的答对的题越多，获得葡萄的数量可能会越多！</span>
        </div>

        <div class="timer">
            <img src="/images/game/酒杯.gif" v-if="wineGlass"/>
            <div class="time">{{second}}</div>
        </div>

        <div class="answer" v-if="questionIndex > 0">
            <div class="seq">
                <span class="current">{{questionIndex}}</span>
                <span class="total">/{{questionCount}}</span>
            </div>
            <div class="description">
                <div class="cont">{{question.desc}}</div>
            </div>
            <div class="options">
                <div class="option" v-for="(option, index) in question.options" :key="index">
                    <div class="head">{{String.fromCharCode(index + 65)}}.</div>
                    <div
                            class="last"
                            :class="{
                'last-correct': optionStatus(option) === 'correct',
                'last-wrong': optionStatus(option) === 'wrong'
            }"
                            @click="answer(option)"
                    >
                        {{option.desc}}
                    </div>
                    <div class="status">
                        <img
                                class="correct-answer"
                                src="/images/game/correct-answer.png"
                                v-if="optionStatus(option) === 'correct'"
                        />
                        <img
                                class="wrong-answer"
                                src="/images/game/wrong-answer.png"
                                v-if="optionStatus(option) === 'wrong'"
                        />
                        <img
                                class="rigth-key"
                                src="/images/game/right-key.png"
                                v-if="optionStatus(option) === 'right'"
                        />
                        <img
                                class="correct-dialog"
                                src="/images/game/correct-dialog.png"
                                v-if="optionStatus(option) === 'correct'"
                        />
                    </div>
                </div>
            </div>
            <img
                    class="timeout-dialog"
                    src="/images/game/timeout-dialog.png"
                    v-if="questionStatus === 'timeout'"
            />
        </div>
    </div>
</template>

<script>
    export default {
        name: "CheckpointPlotScene",
        data() {
            return {
                copyId: 0,
                second: 15,
                timer: null,
                question: {
                    id: 0,
                    desc: "",
                    options: []
                },
                correctOptionId: 0,
                selectedOptionId: 0,
                questionIndex: 0,
                questionCount: 15,
                questionStatus: "answer",
                wineGlass: true
            };
        },
        created() {
            this.$emit("changeBackgroundMusic", "/music/答题页背景音乐.mp3");

            this.init();
        },
        computed: {
            id: function () {
                return this.$store.state.game.currentCheckpointId;
            },
            title: function () {
                return `/images/game/cp-${this.$store.state.game.currentCheckpointId}-subtitle.png`;
            }
        },
        methods: {
            async init() {
                setInterval(this.handleTimer, 1000);

                const response = await this.ajax.doPost({
                    packageName: "game",
                    className: "common",
                    methodName: "startCopy",
                    params: {
                        checkpointId: this.id
                    }
                });

                this.copyId = response;
                this.$store.commit("setCopyId", this.copyId);

                this.questionIndex = 0;

                this.getQuestion();
            },
            async getQuestion() {
                const response = await this.ajax.doPost({
                    packageName: "game",
                    className: "common",
                    methodName: "getQuestion",
                    params: {
                        copyId: this.copyId
                    }
                });

                this.question = response;
                this.questionIndex++;
            },
            optionStatus: function (option) {
                let result = "answer";

                switch (this.questionStatus) {
                    case "correct":
                        if (option.id === this.correctOptionId) {
                            result = "correct";
                        }
                        break;
                    case "wrong":
                        if (option.id === this.correctOptionId) {
                            result = "right";
                        }
                        if (option.id === this.selectedOptionId) {
                            result = "wrong";
                        }
                        break;
                    case "timeout":
                        if (option.id === this.correctOptionId) {
                            result = "right";
                        }
                        break;
                    default:
                }

                return result;
            },
            async answer(option) {
                /**
                 * 不能重复答题
                 */
                if (this.selectedOptionId) {
                    return;
                }

                this.selectedOptionId = option.id;

                const response = await this.ajax.doPost({
                    packageName: "game",
                    className: "common",
                    methodName: "answerQuestion",
                    params: {
                        checkpointId: this.id,
                        copyId: this.copyId,
                        questionId: this.question.id,
                        optionId: this.selectedOptionId,
                        timeCost: 15 - this.second
                    }
                });

                this.correctOptionId = response;

                if (this.selectedOptionId === this.correctOptionId) {
                    this.success();
                } else {
                    this.fail();
                }
            },
            async success() {
                this.$emit("changeForegroundMusic", "/music/场景5操作音乐（答对）.mp3");
                this.questionStatus = "correct";
                await this.sleep(1500);
                this.next();
            },
            async fail() {
                this.$emit("changeForegroundMusic", "/music/场景5操作音乐（答错）.mp3");
                this.questionStatus = "wrong";
                await this.sleep(1500);
                this.next();
            },
            async timeout() {
                this.$emit("changeForegroundMusic", "/music/场景5操作音乐（答错）.mp3");
                this.questionStatus = "timeout";

                this.ajax.doPost({
                    packageName: "game",
                    className: "common",
                    methodName: "answerQuestion",
                    params: {
                        checkpointId: this.id,
                        copyId: this.copyId,
                        questionId: this.question.id,
                        optionId: 0,
                        timeCost: 15
                    }
                });
                await this.sleep(1500);
                this.next();
            },
            async sleep(duration) {
                return new Promise((resolve, reject) => {
                    setTimeout(resolve, duration);
                });
            },
            async next() {
                if (this.questionIndex >= 15) {
                    const response = await this.ajax.doPost({
                        packageName: "game",
                        className: "common",
                        methodName: "closeCopy",
                        params: {
                            copyId: this.copyId
                        }
                    });

                    this.$store.commit("setCurrentCheckpointResult", response);
                    this.$emit("changeScene", "CheckpointResultScene");
                    return;
                }
                await this.getQuestion();

                this.questionStatus = "answer";
                this.correctOptionId = 0;
                this.selectedOptionId = 0;
                this.second = 15;
                this.wineGlass = false;
                const self = this;
                setTimeout(function () {
                    self.wineGlass = true;
                }, 100);
                // this.wineGlass = true;
            },
            handleTimer() {
                if (this.second > 0) {
                    this.second--;
                } else {
                    if (this.questionStatus == "answer") {
                        this.timeout();
                    }
                }
            },
            handleClick() {
                this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
                this.$emit("changeScene", "CheckpointStartScene");
            },
            handleBack() {
                this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
                this.$emit("changeScene", "MainScene");
            }
        }
    };
</script>


<style lang="scss" scoped>
    .scene-checkpoint-answer {
        width: 1100px;
        height: 560px;
        position: relative;

        background-image: url();
        background-size: cover;

        .back-button {
            position: absolute;
            width: 80px;
            height: 40px;
            cursor: pointer;

            img {
                width: 100%;
            }
        }

        @keyframes hu__hu__ {
            50% {
                transform: translateY(20px);
            }
        }

        .sprite {
            position: absolute;
            top: 30px;
            left: 83px;
            width: 271px;
            height: 162px;

            // animation: hu__hu__ infinite 2s ease-in-out;
        }

        .title {
            position: absolute;
            height: 61px;
            top: 50px;
            left: 350px;
        }

        .dialog {
            position: absolute;
            width: 403px;
            height: 22px;
            padding: 15px 35px;
            top: 120px;
            left: 350px;

            background: url(/images/game/dialog-background-2.png);
            background-size: cover;

            .span1 {
                font-size: 18px;
                font-family: "FZFMJW";
                font-weight: normal;
                color: rgba(0, 0, 0, 1);
                line-height: 20px;
            }

            .span2 {
                font-size: 14px;
                font-weight: 400;
                color: rgba(0, 0, 0, 1);
                line-height: 20px;
            }
        }

        .timer {
            position: absolute;
            top: 250px;
            left: -10px;

            width: 167px;
            height: 174px;

            img {
                width: 167px;
                height: 174px;
            }

            .time {
                position: absolute;
                top: 42px;
                left: 42px;
                width: 60px;
                font-size: 30px;
                text-align: center;
                color: white;
                font-family: "DINMedium";
            }
        }

        .correct-dialog {
            position: absolute;

            right: 100px;
            top: -30px;

            width: 223px;
            height: 53px;

            animation: move 3s;
        }

        @keyframes move {
            from {
                top: -30px;
            }

            to {
                top: -300px;
            }
        }

        .timeout-dialog {
            position: absolute;
            left: 300px;
            top: 150px;
            width: 325px;
            height: 82px;
        }

        .answer {
            position: absolute;
            top: 190px;
            left: 124px;
            width: 976px;
            height: 343px;

            background: url(/images/game/answer-background.png);
            background-size: cover;

            .seq {
                position: absolute;
                left: 20px;
                top: 15px;
                font-family: "DINMedium";
                width: 100px;
                text-align: center;

                .current {
                    font-size: 30px;
                }

                .total {
                    font-size: 20px;
                }
            }

            .description {
                position: absolute;
                left: 220px;
                top: 5px;


                height: 56px;
                width: 700px;

                .cont {
                    position: relative;
                    top: 50%;
                    transform: translateY(-50%);

                    font-size: 20px;
                    font-weight: 600;
                    color: rgba(255, 255, 255, 1);
                    line-height: 28px;
                }
            }

            .options {
                position: absolute;
                left: 80px;
                top: 70px;

                .option {
                    margin-top: 15px;
                    // position: absolute;

                    .head {
                        display: inline-block;
                        vertical-align: top;
                        width: 40px;
                        font-size: 22px;
                        font-weight: 600;
                        color: rgba(0, 0, 0, 1);
                        line-height: 48px;
                    }

                    .last {
                        vertical-align: top;
                        display: inline-block;
                        width: 700px;
                        height: 46px;
                        background: linear-gradient(
                                        90deg,
                                        rgba(255, 255, 255, 1) 0%,
                                        rgba(254, 251, 241, 1) 100%
                        );
                        border: 1px solid rgba(212, 193, 168, 1);

                        padding: 0 20px;
                        font-size: 16px;
                        font-weight: 600;
                        color: rgba(0, 0, 0, 1);
                        line-height: 46px;

                        cursor: pointer;
                    }

                    .last:hover {
                        box-shadow: 0 0 10px rgba(151, 102, 5, 0.82);
                    }

                    .last-correct {
                        background: linear-gradient(
                                        90deg,
                                        rgba(245, 224, 181, 1) 0%,
                                        rgba(184, 142, 63, 1) 100%
                        );
                        box-shadow: 3px 3px 0px 0px rgba(0, 0, 0, 1);
                        border: 1px solid rgba(0, 0, 0, 1);
                    }

                    .last-wrong {
                        background: rgba(205, 74, 74, 1);
                        box-shadow: 3px 3px 0px 0px rgba(0, 0, 0, 1);
                        border: 1px solid rgba(0, 0, 0, 1);
                    }

                    .status {
                        vertical-align: top;
                        display: inline-block;

                        .rigth-key {
                            margin: 8px 0 7px 15px;
                            width: 88px;
                            height: 33px;
                        }

                        .correct-answer {
                            margin: 12px 0 12px 15px;
                            width: 32px;
                            height: 24px;
                        }

                        .wrong-answer {
                            margin: 10px 0 10px 15px;
                            width: 28px;
                            height: 28px;
                        }
                    }
                }
            }
        }
    }
</style>